import React from 'react'
import { startOfDay, endOfDay, addDays } from 'date-fns'

import TaskWidget from '@SonarCX/components/molecules/TaskWidget'
import TaskRow from '../TaskRow'
import Information from '../Information'

import useDashboardTasks from '../../hooks/useDashboardTasks'
import useStyles from './styles'

type UpcomingDeadlinesProps = {
  mineOnly: boolean
  upcomingDays: number
  skipDays: number
}

const UpcomingDeadlines: React.FC<UpcomingDeadlinesProps> = ({
  mineOnly,
  upcomingDays,
  skipDays
}) => {
  const { getKey, formatTasks } = useDashboardTasks({
    mineOnly,
    dateRangeStart: startOfDay(addDays(new Date(), skipDays)),
    dateRangeEnd: endOfDay(addDays(new Date(), upcomingDays))
  })
  const classes = useStyles()

  return (
    <TaskWidget
      title={`Due next ${upcomingDays} days`}
      getKey={getKey}
      format={formatTasks}
      rowRenderer={TaskRow}
      noTasksText={`No tasks due in the next ${upcomingDays} days`}
      className={classes.title}
      infoComponent={<Information info='All uncompleted tasks' />}
    />
  )
}

export default UpcomingDeadlines
